import { Component, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { PersonnelModel } from 'src/app/models/personnels/personnel.model';
import { LienTache } from 'src/app/models/taches/gestion-taches.model';
import { PersonnelsService } from 'src/app/services/personnels/personnels.service';
import { base64string } from 'src/app/utils/file-conversions-util';

@Component({
  selector: 'app-lien-personnel-details-tooltip',
  templateUrl: './lien-personnel-details-tooltip.component.html',
  styleUrls: ['./lien-personnel-details-tooltip.component.scss']
})
export class LienPersonnelDetailsTooltipComponent {
  @Input() set lien(value: LienTache) {
    this.idPersonnel = value.idOriginal;
    if (value) {
      this.loadPersonnelDetails()
      this.loadPhoto()
    }
  }
  public personnel: PersonnelModel;
  public photoData: base64string;
  private idPersonnel: number = null;
  public sub: Subscription[] = [];

  constructor(private personnelService: PersonnelsService) { }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.sub.map(ob => ob.unsubscribe());
  }
  
  private loadPersonnelDetails() {
    this.sub.push(
      this.personnelService.getPersonnelDetaille(this.idPersonnel).subscribe(personnel => this.personnel = personnel)
    );
  }

  private loadPhoto() {
    this.sub.push(
      this.personnelService.chargerPhotoAsBase64(this.idPersonnel).subscribe(photoData => this.photoData = photoData)
    );
  }
}

